import { motion } from 'framer-motion';
import { Wrench, Clock, Mail } from 'lucide-react';

const Maintenance = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Icon */}
          <motion.div
            className="flex justify-center mb-8"
            animate={{ rotate: [0, 10, -10, 10, 0] }}
            transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
          >
            <div className="bg-accent-500/20 p-6 rounded-full">
              <Wrench className="w-20 h-20 text-accent-500" />
            </div>
          </motion.div>

          {/* Title */}
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Website Under Maintenance
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-300 mb-8">
            We're currently making some improvements to serve you better.
            <br />
            We'll be back online shortly!
          </p>

          {/* Time estimate */}
          <div className="flex items-center justify-center gap-3 text-accent-400 mb-12">
            <Clock className="w-5 h-5" />
            <span className="text-lg">Expected back soon</span>
          </div>

          {/* Contact info */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Mail className="w-5 h-5 text-accent-400" />
              <h2 className="text-xl font-semibold text-white">Need immediate assistance?</h2>
            </div>
            <p className="text-gray-300 mb-4">
              For urgent matters, please reach out to us at:
            </p>
            <a
              href="mailto:contact@wayforwardtech.com"
              className="text-accent-400 hover:text-accent-300 font-semibold text-lg transition-colors"
            >
              contact@wayforwardtech.com
            </a>
          </div>

          {/* Animated dots */}
          <motion.div
            className="flex justify-center gap-2 mt-12"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                className="w-3 h-3 bg-accent-500 rounded-full"
                animate={{
                  scale: [1, 1.5, 1],
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  delay: i * 0.2,
                }}
              />
            ))}
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Maintenance;
